import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var HomeIcon = function HomeIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "HomeIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7.541 1.153a.76.76 0 0 1 .918 0l4.97 3.74A2.69 2.69 0 0 1 14.5 7.041v5.945c0 .54-.22 1.055-.604 1.431-.384.375-.9.583-1.435.583H3.539a2.05 2.05 0 0 1-1.435-.583 2 2 0 0 1-.604-1.43V7.04c0-.845.397-1.64 1.07-2.148zM8 2.726 3.488 6.121a1.15 1.15 0 0 0-.459.92v5.945c0 .121.05.241.143.332a.53.53 0 0 0 .367.148h1.785V9.918c0-.953.77-1.726 1.72-1.726h1.912c.95 0 1.72.773 1.72 1.726v3.548h1.785a.53.53 0 0 0 .367-.147.47.47 0 0 0 .143-.333V7.041c0-.362-.17-.703-.46-.92zm1.147 10.74V9.918a.19.19 0 0 0-.191-.192H7.044a.19.19 0 0 0-.191.192v3.548z",
      clipRule: "evenodd"
    })
  }));
};

export { HomeIcon };
